import React from "react";

class Header extends React.Component {
  render() {
    return (
      <React.Fragment>
        <header id="header" class="fixed-top d-flex align-items-center">
          <div class="container d-flex align-items-center">
            <div class="logo mr-auto">
              <h1>
                <a href="index.html">Gemo-Trade AG</a>
              </h1>
            </div>
            <nav class="nav-menu d-none d-lg-block">
              <ul>
                <li>
                  <a href="#header">Home</a>
                </li>
                <li>
                  <a href="#about">Dienstleistungen</a>
                </li>
                <li>
                  <a href="#contact">Kontakt</a>
                </li>
              </ul>
            </nav>

            <div class="header-social-links">
              <a href="#" class="twitter">
                <i class="icofont-twitter"></i>
              </a>
              <a href="#" class="facebook">
                <i class="icofont-facebook"></i>
              </a>
              <a href="#" class="linkedin">
                <i class="icofont-linkedin"></i>
              </a>
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

export default Header;
